import { render, staticRenderFns } from "./ManageReportPhotos.vue?vue&type=template&id=38ac8d1a&"
import script from "./ManageReportPhotos.vue?vue&type=script&lang=js&"
export * from "./ManageReportPhotos.vue?vue&type=script&lang=js&"
import style0 from "./ManageReportPhotos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports